import { render, staticRenderFns } from "./SquareHexagon.vue?vue&type=template&id=4c3be40d&"
import script from "./SquareHexagon.vue?vue&type=script&lang=js&"
export * from "./SquareHexagon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports